if(typeof _GIRL_CONF['cherry']['game_memory']=='undefined'){_GIRL_CONF['cherry']['game_memory']={};};
_GIRL_CONF['cherry']['game_memory']['earl']={left:501,top:49,width:92,height:102};
_GIRL_CONF['cherry']['game_memory']['earr']={left:665,top:35,width:76,height:105};
_GIRL_CONF['cherry']['game_memory']['face']={left:603,top:153,width:128,height:156};
_GIRL_CONF['cherry']['game_memory']['hair']={left:483,top:62,width:239,height:370};
_GIRL_CONF['cherry']['game_memory']['handl']={left:460,top:295,width:287,height:266};
_GIRL_CONF['cherry']['game_memory']['handr']={left:548,top:300,width:294,height:332};
_GIRL_CONF['cherry']['game_memory']['item1']={left:192,top:288,width:228,height:438};
_GIRL_CONF['cherry']['game_memory']['item2']={left:869,top:408,width:146,height:293};
_GIRL_CONF['cherry']['game_memory']['titl']={left:540,top:400,width:134,height:123};
_GIRL_CONF['cherry']['game_memory']['titr']={left:657,top:394,width:102,height:120};
